<!-- *************************************************************************
	TEMPLATE
	************************************************************************* -->

<template>
	<div class="WordSection1">
		<p class="MsoNormal" align="center" style="margin-bottom:7.5pt;text-align:center; line-height:normal;background:white">
			<b><span lang="EN-US" style='font-size:11.5pt; font-family:"Arial",sans-serif;color:#333333'>End User Agreement</span></b>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626'
				><br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" align="center" style="margin-bottom:7.5pt;text-align:center; line-height:normal;background:white">
			<b
				><span lang="EN-US" style='font-size:11.5pt; font-family:"Arial",sans-serif;color:#333333'
					>User's Responsibilities</span
				></b
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626'
				><br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>This agreement is between Medavie Blue Cross (Blue Cross) and the user (You or Your) of the web portals, web
				applications, interfaces, tools and systems made available by Blue Cross through this website (collectively, and
				individually, Site). This agreement applies to all users of the Site, regardless of whether You are a member,
				participant, authorized representative of a member or a participant, group administrator, health professional or any
				other person accessing or using the Site.
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>If You are a user of the Group Administrator or the Health Professional secure sections of the Site, Blue Cross
				refers to the organization that issues the benefit plan or policy of insurance of which You are the group
				administrator or of which Your client is a member or participant. More particularly, Blue Cross refers either to
				Medavie Blue Cross or Saskatchewan Blue Cross.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>By accessing or using the Site, You agree to the following terms and conditions. These terms and conditions
				incorporate:</span
			>
		</p>

		<ul type="disc">
			<li class="MsoNormal" style="color:#262626;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif'
					>The Blue Cross privacy statement (available here:&nbsp;</span
				><span style="color:black"
					><a href="#" @click="trackTabs('https://www.medaviebc.ca/en/legal/privacy', 'PRIVACY')"
						><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#0078A7'
							>https://www.medaviebc.ca/en/legal/privacy</span
						></a
					></span
				><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif'>&nbsp;and&nbsp;</span
				><span style="color:black"
					><a href="#" @click="trackTabs('http://www.sk.bluecross.ca/privacy/', 'PRIVACYSK')"
						><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#0078A7'
							>http://www.sk.bluecross.ca/privacy/</span
						></a
					></span
				><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif'>)</span>
			</li>
		</ul>

		<p
			class="MsoNormal"
			style="margin-top:0cm;margin-right:0cm;margin-bottom:0cm; margin-left:36.0pt;line-height:normal;background:white"
		>
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626'>and</span>
		</p>

		<ul type="disc">
			<li class="MsoNormal" style="color:#262626;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif'
					>The Blue Cross website legal notice (available here:&nbsp;</span
				><span style="color:black"
					><a href="#" @click="trackTabs('https://www.medaviebc.ca/en/legal', 'LEGAL')"
						><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#0078A7'
							>https://www.medaviebc.ca/en/legal</span
						></a
					></span
				><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif'>&nbsp;and&nbsp;</span
				><span style="color:black"
					><a href="#" @click="trackTabs('http://www.sk.bluecross.ca/legal/', 'LEGALSK')"
						><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#0078A7'
							>http://www.sk.bluecross.ca/legal/</span
						></a
					></span
				><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif'>&nbsp;).</span>
			</li>
		</ul>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626'
				><br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>These terms and conditions, together with all applicable privacy statement, legal notice, policies and agreements
				referenced in these terms and conditions, form Blue Cross's agreement with You.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>Blue Cross may change the Site and/or this agreement, including the applicable privacy statement, legal notice and
				agreements referenced hereto with or without Your consent. Blue Cross will notify You of any change to these terms and
				conditions upon Your access or use of this Site. If You continue to access or use this Site after any such change is
				effective, You will be deemed to have accepted the change.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<b
				><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626; background:white'
					>1. Confidentiality, Privacy and Security Obligations</span
				></b
			><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626'
				><br />
				<br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(1) The information, material and content accessible in the pages of this Site, as well as any other information
				obtained from, or communicated to, Blue Cross through the use of this Site, including information about an
				identifiable individual, health information, financial information or any other information which could identify a
				person, group or program, are strictly confidential (collectively, Information).</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(2) You will preserve the confidentiality of Information and protect and safeguard it against loss or theft, as well
				as unauthorized access, disclosure, copying, use or modification.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(3) You will ensure that all Information transmitted or modified through the use of this Site is accurate, complete
				and timely.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(4) You will protect and safeguard all Information. This includes, but is not limited to, keeping Information in a
				secure area, using passwords to protect files, protecting Information transmitted electronically or communicated by
				telephone, including Information sent by electronic mail.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(5) You will keep control of Your personal login ID and password. You agree to be liable for all uses of Your
				personal login ID and password, including unauthorized use without Your consent, and You acknowledge that Blue Cross
				shall not be responsible for confirming the identity of any user.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(6) You will not communicate, divulge or disclose any Information gained by accessing or using the Site without the
				consent of the individual to whom the Information pertains.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(7) You will promptly advise Blue Cross of any complaints or disputes regarding the Information.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(8) You will immediately report any breaches of privacy and/or confidentiality to Blue Cross.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(9) If Your relationship with Blue Cross changes and the access and/or use of the Site is no longer required to
				discharge Your duties, Your right to access and/or use the Site is immediately terminated or revoked. Upon termination
				or revocation, You will immediately cease all access and/or use of the Site.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<b
				><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626; background:white'
					>2. Consent to Collection and Use of Usage Data</span
				></b
			><span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626'
				><br />
				<br />
				<br />
			</span>
		</p>

		<p
			class="MsoNormal"
			style="margin-bottom:7.5pt;line-height:normal;background:
white"
		>
			<span
				lang="EN-US"
				style='font-size:11.5pt;font-family:"Arial",sans-serif;
color:#262626'
				>In order to provide You and others with a useful experience through the Site, Blue Cross will collect certain
				information about how You interact with and use the Site. In connection with this, You agree that Blue Cross may
				collect and use technical data, including but not limited to Your IP address, operating system and browser, to improve
				Your user experience and the user experiences of others, and facilitate the provision of product support and other
				services (if any) related to the Site. Blue Cross may use this information for any purpose described in this paragraph
				and any related purpose, as long as it is in a form that does not personally identify You.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<b
				><span
					lang="EN-US"
					style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626;
background:white'
					>3. Additional Obligations Based on Your Relationship with Blue Cross:</span
				></b
			><span
				lang="EN-US"
				style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626;
background:white'
				><br />
				<br />
				<b
					><span style="background:white"
						>(1) If You are a user of the Group Administrator secure section of this Site, You further agree
						that:</span
					></b
				><br />
				<br />
				<br />
			</span>
		</p>

		<ol start="1" type="a">
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Your access or use of the Site is also subject to the terms of any benefit plan or policy of insurance that
					Your employer or client has with Blue Cross.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>You will access, use, copy or modify the information contained on this Site solely for the purposes of
					administering the benefit plan or policy of insurance and performing the obligations and duties described
					therein.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>You will ensure that, if another individual requires access to this Site, they will obtain their own personal
					login ID and password.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>You will retain all original records and forms required by Blue Cross.</span
				>
			</li>
		</ol>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626'
				><br />
				<b
					><span style="background:white"
						>(2) If You are a user of the Health Professional secure section of the Site, You further agree
						that:</span
					></b
				><br />
				<br />
				<br />
			</span>
		</p>

		<ol start="1" type="a">
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>For the purposes of this section 3.(2), if You use the Blue Cross Provider Electronic Claims Submission
					Service System (the System) to submit online billings, these terms and conditions incorporate:</span
				>
			</li>
			<ul type="circle">
				<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
					<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
						>The Blue Cross electronic claims submission agreement (available within the Health Professional
						component of this Site).</span
					>
				</li>
			</ul>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>If Your access to the System or Your approval status as a Blue Cross Provider is suspended or terminated, or
					if the electronic claims submission agreement between You and Blue Cross is terminated, Your right to access
					and/or use of the Site is immediately terminated or revoked. Upon termination or revocation, You will
					immediately cease all access and/or use of the Site.</span
				>
			</li>
		</ol>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626'
				><br />
				<b
					><span style="background:white"
						>(3) If you are a user of the NSPMP eAccess web application section of this Site, You further agree
						that:</span
					></b
				><br />
				<br />
				<br />
			</span>
		</p>

		<ol start="1" type="a">
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>You will adhere to the provisions of the NSPMP's policies and procedures.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>You understand that all information You have access to under the NSPMP eAccess web application is
					confidential and is not to be discussed with or communicated to anyone who is not authorized to know the
					information in any manner, except in accordance with the NSPMP's policies and procedures regarding same.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>You will not access nor use information except as it is necessary to perform Your duties and/or as You are
					authorized to do so by the NSPMP.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>You will immediately report any breaches of privacy and/or confidentiality to the NSPMP.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>You understand that it is Your responsibility to secure information to which You have access in accordance
					with the policies and procedures of the NSPMP governing the security of information.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>You understand that if You have questions or concerns respecting access, disclosure or use of information,
					You are responsible for addressing those questions or concerns with the NSPMP.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>If You inadvertently breach any of the provisions of the NSPMP's policies regarding the access, disclosure or
					use of information, or cause a security breach which could lead to improper disclosure of information held by
					the NSPMP or improper access by others to information held by the NSPMP, You understand that a record of the
					breach will be maintained by the NSPMP and that You may be required to undertake additional privacy and
					security education.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Should You willfully breach any of the provisions of the NSPMP's policies respecting the access, disclosure
					or use of information or cause a security breach which could lead to improper disclosure of information held
					by the NSPMP or improper access by others to information held by the NSPMP, You understand that You may have
					Your access revoked and/or face disciplinary action with Your licensing authority.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>You agree to keep Your password absolutely confidential; You will not share Your password with anyone. If You
					suspect that someone else knows Your password You must immediately notify the NSPMP.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>If there is a conflict between any provision of this subsection 3(3) and any other provision of this
					agreement, the relevant provision of this subsection 3(3) shall prevail.</span
				>
			</li>
		</ol>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#262626'
				><br />
				<b><span style="background:white">4. General</span></b
				><br />
				<br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(1) Your failure to comply with any term or condition of this agreement may lead to immediate termination of Your
				access to the Site, without limiting any other remedies Blue Cross may be entitled to bring at law or in equity for
				further enforcement of the agreement.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(2) This agreement will be governed by the laws applicable in the Canadian jurisdiction that governs any applicable
				benefit plan or policy of insurance with Blue Cross, or any applicable program administered by Blue Cross. In the
				absence of such a benefit plan or policy, or if multiple benefit plans or policies are applicable and are subject to
				differing jurisdictions, this agreement shall be governed by the laws applicable in the province of New Brunswick. You
				irrevocably submit to the jurisdiction of the applicable courts in such jurisdiction. The parties hereby waive any
				right to a jury trial.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>(3) You agree that each and every term of this agreement is of the essence. If any one or more of the provisions
				contained in this agreement should be declared invalid, illegal or unenforceable in any respect, the validity,
				legality and enforceability of the remaining provisions contained in this agreement shall not in any way be affected
				or impaired so long as the commercial, economic and legal substance of the transaction contemplated hereby are not
				affected in any manner materially adverse to any Party. Upon such a declaration, the Parties shall modify this
				Agreement so as to carry out the original intent of the Parties as closely as possible in an acceptable manner so that
				the purposes contemplated hereby are consummated as originally contemplated to the fullest extent possible.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background: white">
			<span lang="EN-US" style='font-size:11.5pt;font-family:"Arial",sans-serif; color:#262626'
				>By accessing or using the Site, You declare having read this agreement and understood Your obligations and
				responsibilities hereunder.</span
			>
		</p>

		<div tabindex="0" />
	</div>
</template>
<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import IdMixin from '@/mixins/id';
import TabTrackerMixin from '@/mixins/tabs';

@Component({
	name: 'UserAgreementEn',
	mixins: [IdMixin, TabTrackerMixin]
})
export default class UserAgreementEn extends Vue {}
</script>
<style lang="scss" @scoped>
/* Font Definitions */
@font-face {
	font-family: Wingdings;
	panose-1: 5 0 0 0 0 0 0 0 0 0;
}
@font-face {
	font-family: 'Cambria Math';
	panose-1: 2 4 5 3 5 4 6 3 2 4;
}
@font-face {
	font-family: Calibri;
	panose-1: 2 15 5 2 2 2 4 3 2 4;
}
@font-face {
	font-family: 'Segoe UI';
	panose-1: 2 11 5 2 4 2 4 2 2 3;
}
/* Style Definitions */
p.MsoNormal,
li.MsoNormal,
div.MsoNormal {
	margin-top: 0cm;
	margin-right: 0cm;
	margin-bottom: 8pt;
	margin-left: 0cm;
	line-height: 107%;
	font-size: 11pt;
	font-family: 'Calibri', sans-serif;
}
p.MsoHeader,
li.MsoHeader,
div.MsoHeader {
	mso-style-link: 'Header Char';
	margin: 0cm;
	font-size: 11pt;
	font-family: 'Calibri', sans-serif;
}
p.MsoFooter,
li.MsoFooter,
div.MsoFooter {
	mso-style-link: 'Footer Char';
	margin: 0cm;
	font-size: 11pt;
	font-family: 'Calibri', sans-serif;
}
span.HeaderChar {
	mso-style-name: 'Header Char';
	mso-style-link: Header;
}
span.FooterChar {
	mso-style-name: 'Footer Char';
	mso-style-link: Footer;
}
p.DocsID,
li.DocsID,
div.DocsID {
	mso-style-name: DocsID;
	mso-style-link: 'DocsID Char';
	margin-right: 0cm;
	margin-left: 36pt;
	text-indent: -18pt;
	background: white;
	font-size: 8pt;
	font-family: 'Arial', sans-serif;
	color: navy;
}
span.DocsIDChar {
	mso-style-name: 'DocsID Char';
	mso-style-link: DocsID;
	font-family: 'Arial', sans-serif;
	color: navy;
	background: white;
}
.MsoChpDefault {
	font-family: 'Calibri', sans-serif;
}
.MsoPapDefault {
	margin-bottom: 8pt;
	line-height: 107%;
}
/* Page Definitions */
@page WordSection1 {
	size: 612pt 792pt;
	margin: 72pt 72pt 72pt 72pt;
}
div.WordSection1 {
	page: WordSection1;
}
/* List Definitions */
ol {
	margin-bottom: 0cm;
}
ul {
	margin-bottom: 0cm;
}
</style>
